import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-news",
  templateUrl: "./news.component.html",
  styleUrls: ["./news.component.scss"]
})
export class NewsComponent {
  get news() {
    return this.translate.currentLang === "en" ? this.news_EN : this.news_FR;
  }

  constructor(public translate: TranslateService) {}

  news_EN = [
    {
      date: "23/04",
      category: "NEWS SITE",
      title: "The Keyraken mission is available!"
    },
    {
      date: "25/04",
      category: "BUGFIX",
      title:
        "Minor bug fixes. The wave card is now by default in the reveal area."
    },
    {
      date: "25/04",
      category: "UPDATE",
      title:
        "Tokens are now fully removed when dragging and dropping into the discard / deck / discard area."
    },
    {
      date: "27/04",
      category: "NEWS SITE",
      title: "Game is available in both French and English lang"
    },
    ,
    {
      date: "27/04",
      category: "BUGFIX",
      title: "Tide card is fixed, side stay the same change when drag&drop."
    },
    ,
    {
      date: "27/04",
      category: "BUGFIX",
      title: "Hovering deck is fixed."
    },
    ,
    {
      date: "28/04",
      category: "UPDATE",
      title: "Tokens improvement."
    },
    {
      date: "10/05",
      category: "UPDATE",
      title: "TVS have been migrated to another host."
    }
  ];

  news_FR = [
    {
      date: "23/04",
      category: "NEWS SITE",
      title: "La mission Keyraken est disponible !"
    },
    {
      date: "25/04",
      category: "BUGFIX",
      title:
        "Corrections de bugs mineurs. La carte vague est désormais par défaut dans la zone reveal."
    },
    {
      date: "25/04",
      category: "UPDATE",
      title:
        "Les tokens sont désormais entièrement retirés quand drag&drop dans la zone de défausse/deck/discard."
    },
    {
      date: "27/04",
      category: "NEWS SITE",
      title: "Le site est désormais disponible en Francais et en Anglais."
    },
    {
      date: "27/04",
      category: "BUGFIX",
      title: "La carte de marée ne change plus de côté quand drag&drop."
    },
    {
      date: "27/04",
      category: "BUGFIX",
      title: "Survoler le deck n'affiche plus la prochaine carte."
    },
    {
      date: "28/04",
      category: "UPDATE",
      title: "Amélioration des tokens: l'ajout / retrait est plus rapide."
    },
    {
      date: "10/05",
      category: "UPDATE",
      title: "Changement d'hébergeur."
    }
    /* {
      date: '06/07',
      category: 'NEWS ISSUES',
      title: 'You can submit your issues on github, see the /about link.'
    },
    {
      date: '08/07',
      category: 'NEWS SITE',
      title: 'You can send your messages to thevibraniumsociety@gmail.com, see our /about link.'
    },
    {
      date: '18/07',
      category: 'NEWS SITE',
      title: 'Deck creation is available ! Check the /deck link.'
    },
    {
      date: '18/08',
      category: 'NEWS SITE',
      title: 'Progress & achievements page is available ! Check the /progression link.'
    },
    {
      date: '27/08',
      category: 'NEWS SITE',
      title: 'You can now import decks from https://marvelcdb.com/'
    }*/
  ];
}
